if (typeof debounce === 'undefined') {
  var debounce = function (fn, wait) {
    let t;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      this.a_bar = document.querySelector('.announcement-bar-section');

      this.isTransitioning = false;
      this.lastScrollPos = 0;

      document.addEventListener('keyup', (e) => {
        if (e.code && e.code.toUpperCase() === 'ESCAPE') {
          this.toggle.removeAttribute('open');
          this.toggle.classList.remove('active');
          if (this.classList.contains('mk-msearch-open')) {
            this.setMobileSearch(false);
            this.searchToggle.focus();
          }
        }
      });

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          if (this.classList.contains('mk-msearch-open')) this.setMobileSearch(false);
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Mobil: Lupe klappt das Suchfeld auf/zu (Stefan 02.11.2026)
      this.searchToggle = this.querySelector('.mk-msearch-toggle');
      if (this.searchToggle) {
        this.searchToggle.addEventListener('click', () => {
          this.setMobileSearch(!this.classList.contains('mk-msearch-open'));
        });
        const cc = this.querySelector('.searchform--click-capture');
        if (cc) cc.addEventListener('click', () => this.setMobileSearch(false));
        const menuSearch = this.querySelector('.mk-menu-search--field');
        if (menuSearch) menuSearch.addEventListener('click', () => this.setMobileSearch(true));

        // Zugeklappte Suche darf die Seite nicht sperren: laufende Anfragen/Debounce setzen open-search sonst nachtraeglich
        this._mobilMql = window.matchMedia('(max-width: 1067.98px)');
        this._sperreLoesen = () => {
          if (!this._mobilMql.matches || this.classList.contains('mk-msearch-open') || !document.body.classList.contains('open-search')) return;
          const form = this.querySelector('search-form');
          if (form && typeof form.close === 'function') form.close();
          document.body.classList.remove('open-search');
        };
        this._sperreObserver = new MutationObserver(this._sperreLoesen);
        this._sperreObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        this._mobilMql.addEventListener('change', this._sperreLoesen);
      }

      // Cache sticky offset once — only needs recalculating on resize, not every scroll
      this._stickyOffset = this.offsetTop;

      // Store bound references for disconnectedCallback cleanup
      this._onScroll = this._scrollHandler.bind(this);
      this._onResize = this._resizeHandler.bind(this);

      // Single passive scroll handler replaces four separate scroll listeners
      window.addEventListener('scroll', this._onScroll, { passive: true });

      // Resize handler for values that only change on resize, not scroll
      window.addEventListener('resize', this._onResize, { passive: true });

      // Initial state: Layout-Reads VOR den :root-Writes (_stickyOffset ist oben schon gecacht).
      // _scrollHandler schreibt --header-offset/--header-height auf :root; ein Layout-Read danach
      // (bisher offsetTop in _resizeHandler) erzwingt einen Style-Recalc ueber das ganze Dokument.
      const announcementHeight = this.a_bar ? this.a_bar.clientHeight : null;
      this._scrollHandler();
      if (announcementHeight !== null) {
        document.documentElement.style.setProperty('--announcement-height', announcementHeight + 'px');
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');
        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    setMobileSearch(open) {
      // Offenes Menue liegt ueber dem Suchfeld: sofort schliessen, sonst bleibt die Suche dahinter
      if (open && this.toggle.hasAttribute('open')) {
        this.toggle.removeAttribute('open');
        this.toggle.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
      this.classList.toggle('mk-msearch-open', open);
      this.searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      const form = this.querySelector('search-form');
      if (open) {
        // focus() synchron im Klick, sonst oeffnet iOS die Tastatur nicht
        const input = this.querySelector('#header-search-input');
        if (input) input.focus();
      } else {
        if (form && typeof form.close === 'function') form.close();
        if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur();
      }
      // Header-Hoehe hat sich geaendert: --header-height sofort nachziehen (Overlay/Dropdown-Position)
      this._scrollHandler();
    }

    disconnectedCallback() {
      if (this._sperreObserver) {
        this._sperreObserver.disconnect();
        this._mobilMql.removeEventListener('change', this._sperreLoesen);
      }
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
    }

    _scrollHandler() {
      // Batch all reads first, then all writes — one layout per scroll tick
      const scrollY        = window.scrollY;
      const headerHeight   = this.clientHeight;
      // Ganze px + Kappung auf -headerHeight: ist der Header komplett aus dem Viewport, aendert sich
      // der Wert nicht mehr -> kein :root-Write (= dokumentweiter Style-Recalc) pro Scroll-Frame.
      const headerTop      = Math.max(Math.round(this.header_section.getBoundingClientRect().top), -headerHeight);

      if (this.classList.contains('header-sticky--active')) {
        this.classList.toggle('is-sticky', scrollY >= this._stickyOffset && scrollY > 0);
      }
      if (headerTop !== this._lastHeaderTop) {
        this._lastHeaderTop = headerTop;
        document.documentElement.style.setProperty('--header-offset', headerTop + 'px');
      }
      if (headerHeight !== this._lastHeaderHeight) {
        this._lastHeaderHeight = headerHeight;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      }
      this._handleScrollDirection(scrollY);
    }

    _resizeHandler() {
      // Recache sticky offset after layout changes
      this._stickyOffset = this.offsetTop;

      // Announcement height never changes on scroll, only on resize
      if (this.a_bar) {
        document.documentElement.style.setProperty('--announcement-height', this.a_bar.clientHeight + 'px');
      }
    }

    _handleScrollDirection(scrollY) {
      if (!this.isTransitioning && this.classList.contains('header-hide-menu--active')) {
        if (scrollY < 200) {
          this.showMenu();
        } else if (this.lastScrollPos < scrollY) {
          this.hideMenu();
        } else if (this.lastScrollPos - 5 > scrollY) {
          this.showMenu();
        }
        this.lastScrollPos = scrollY;
      }
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const parentLinks = this.menu.dataset.parentLinks === 'true';

      if (parentLinks) {
        event.preventDefault();

        const isArrow = event.target.closest('summary > span');

        if (isArrow) {
          if (detailsElement.hasAttribute('open')) {
            detailsElement.removeAttribute('open');
            return;
          }
          detailsElement.setAttribute('open', '');
        } else {
          const anchor = summaryElement.querySelector('a');
          if (anchor && anchor.href) {
            window.location.href = anchor.href;
          }
          return;
        }
      }

      // Clone deferred template on first open (v9-Backport)
      const tpl = detailsElement.querySelector(':scope > template.mobile-menu-deferred');
      if (tpl) {
        tpl.replaceWith(tpl.content.cloneNode(true));

        // Re-bind listeners for newly cloned elements.
        // Auf .sub-menu gescopet: der breite v11-Selektor ('details.link-container summary')
        // matcht sonst auch die EIGENE Top-Level-Summary und bindet sie doppelt —
        // bricht den Parent-Links-Pfeil-Toggle dauerhaft (Upstream-Bug in v11).
        detailsElement.querySelectorAll('.parent-link-back--button').forEach(button =>
          button.addEventListener('click', this.onCloseButtonClick.bind(this))
        );
        detailsElement.querySelectorAll('.sub-menu details.link-container summary').forEach(summary =>
          summary.addEventListener('click', this.onSummaryClick.bind(this))
        );

        // Inline-Script im Menue-Snippet stellt danach den gespeicherten Zustand wieder her
        document.dispatchEvent(new CustomEvent('mobile-menu:submenu-cloned', { detail: { details: detailsElement } }));
      }

      // Only reset scroll position when opening a top-level sub-menu (which slides in as a new view).
      // Nested accordion details inside an already-open sub-menu should not jump the menu to the top.
      const isTopLevel = !detailsElement.parentElement.closest('details');
      if (isTopLevel && this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }

    showMenu() {
      this.classList.remove('header--unpin');
      this.isTransitioning = true;
      setTimeout(() => {
        this.lastScrollPos = window.scrollY;
        this.isTransitioning = false;
        this._handleScrollDirection(window.scrollY);
      }, 300);
    }

    hideMenu() {
      if (!this.isTransitioning) {
        this.classList.add('header--unpin');
        this.isTransitioning = true;
        setTimeout(() => {
          this.lastScrollPos = window.scrollY;
          this.isTransitioning = false;
          this._handleScrollDirection(window.scrollY);
        }, 300);
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // DOM queries moved from constructor to connectedCallback
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');

      document.fonts.ready.then(() => {
        window.addEventListener('resize', debounce(() => {
          this.setMenuHeight();
          if (!this.submenus.length) {
            return;
          }
          this.resizeSubMenus();
        }, 100));
      });

      // Defer layout read until after paint
      requestAnimationFrame(() => this.setMenuHeight());
    }

    resizeSubMenus() {
      // Batch all reads across all submenus first, then apply all writes
      const results = [];
      this.submenus.forEach((submenu) => {
        submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu').forEach((subSubmenu) => {
          results.push({
            el: subSubmenu.parentElement,
            overflowing: subSubmenu.getBoundingClientRect().right > window.innerWidth
          });
        });
      });
      results.forEach(({ el, overflowing }) => {
        el.classList.toggle('left-submenu', overflowing);
      });
    }

    setMenuHeight() {
      let h = this.clientHeight;
      if (h > 20) {
        document.documentElement.style.setProperty('--menu-height', h + 'px');
      }
    }
  }

  customElements.define('full-menu', FullMenu);
}
